// extracted by mini-css-extract-plugin
export default {"tags":"ReactTags_tags__czyeQ","tag":"ReactTags_tag__NFgqT","tagInput":"ReactTags_tagInput__C5OFL","clearButton":"ReactTags_clearButton__zUcHY"};